<section class="sk-use">
  <h3 class="sk-h3">
    {{ 'skillManagement.usage.title' | translate }}
    @if (state === 'ready') {
      <span class="sk-h3__note">
        {{
          'skillManagement.usage.summary'
            | translate: { consultants: groups.length, projects: projectCount }
        }}
      </span>
    }
  </h3>

  @switch (state) {
    @case ('loading') {
      <div class="sk-none" role="status">
        {{ 'skillManagement.usage.loading' | translate }}
      </div>
    }
    @case ('error') {
      <div class="sk-none sk-none--error" role="alert">
        {{ 'skillManagement.usage.error' | translate }}
      </div>
    }
    @default {
      @if (!hasUsage) {
        <div class="sk-none">
          {{ 'skillManagement.usage.none' | translate }}
        </div>
      } @else {
        <div class="sk-use__bar">
          <span class="sk-use__label">{{
            'skillManagement.usage.minExperience' | translate
          }}</span>
          <div
            class="seg"
            role="group"
            [attr.aria-label]="
              'skillManagement.usage.minExperience' | translate
            "
          >
            @for (preset of presets; track preset) {
              <button
                type="button"
                class="seg__opt"
                [class.seg__opt--on]="minMonths === preset"
                [attr.aria-pressed]="minMonths === preset"
                (click)="setMinMonths(preset)"
              >
                {{
                  presetLabel(preset).key
                    | translate: { count: presetLabel(preset).value }
                }}
              </button>
            }
          </div>
          <label class="sk-use__min">
            <input
              class="bf-input"
              type="number"
              min="0"
              step="1"
              [ngModel]="minMonths"
              (ngModelChange)="setMinMonths($event)"
              [attr.aria-label]="
                'skillManagement.usage.minMonthsLabel' | translate
              "
            />
            <span>{{ 'skillManagement.usage.monthsUnit' | translate }}</span>
          </label>
          <label class="sk-use__sort">
            <span class="sk-use__label">{{
              'skillManagement.usage.sort' | translate
            }}</span>
            <select
              class="mini-select"
              [ngModel]="sort"
              (ngModelChange)="setSort($event)"
            >
              <option value="duration">
                {{ 'skillManagement.usage.sortDuration' | translate }}
              </option>
              <option value="name">
                {{ 'skillManagement.usage.sortName' | translate }}
              </option>
            </select>
          </label>
        </div>

        <div class="sk-tbl-scroll">
          <div class="sk-tbl" role="table">
            <div class="sk-tr sk-tr--head" role="row">
              <span role="columnheader">{{
                'skillManagement.usage.colConsultant' | translate
              }}</span>
              <span role="columnheader">{{
                'skillManagement.usage.colProject' | translate
              }}</span>
              <span role="columnheader" class="sk-tr__wide">{{
                'skillManagement.usage.colPeriod' | translate
              }}</span>
              <span role="columnheader" class="sk-r sk-tr__wide">{{
                'skillManagement.usage.colDuration' | translate
              }}</span>
            </div>
            @for (group of visibleGroups; track group.id) {
              <div class="sk-grp" role="rowgroup">
                <div
                  class="sk-tr sk-grp__head"
                  role="row"
                  tabindex="0"
                  [attr.aria-expanded]="isOpen(group)"
                  (click)="toggle(group)"
                  (keydown.enter)="toggle(group)"
                  (keydown.space)="$event.preventDefault(); toggle(group)"
                >
                  <span class="sk-user" role="cell">
                    <span
                      class="sk-user__chev"
                      [class.sk-user__chev--open]="isOpen(group)"
                      ><app-skill-icon name="chevron" [size]="16"
                    /></span>
                    <span class="sk-user__name" [title]="group.name">{{
                      group.name
                    }}</span>
                    <a
                      class="sk-prof"
                      [href]="profileUrl(group)"
                      target="_blank"
                      rel="noopener"
                      (click)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()"
                      [title]="
                        'skillManagement.usage.profileLabel'
                          | translate: { name: group.name }
                      "
                      [attr.aria-label]="
                        'skillManagement.usage.profileLabel'
                          | translate: { name: group.name }
                      "
                    >
                      {{ 'skillManagement.usage.profile' | translate
                      }}<app-skill-icon name="external" [size]="13" />
                    </a>
                  </span>
                  <span class="sk-muted" role="cell">
                    {{
                      (group.projects.length === 1
                        ? 'skillManagement.usage.projectOne'
                        : 'skillManagement.usage.projects'
                      ) | translate: { count: group.projects.length }
                    }}
                  </span>
                  <span role="cell" class="sk-tr__wide"></span>
                  <span class="sk-r sk-tr__wide" role="cell">
                    <span
                      class="sk-total"
                      [title]="'skillManagement.usage.totalTitle' | translate"
                    >
                      {{
                        'skillManagement.usage.months'
                          | translate: { count: group.total }
                      }}
                    </span>
                  </span>
                </div>
                @if (isOpen(group)) {
                  @for (row of group.projects; track $index) {
                    <div class="sk-tr sk-row" role="row">
                      <span role="cell"></span>
                      <span class="sk-proj" role="cell">
                        {{ row.project.projektname }}
                        @if (row.project.aufgaben.length > 0) {
                          <span class="sk-tasks">
                            @for (task of row.project.aufgaben; track $index) {
                              <span class="sk-task">{{ task }}</span>
                            }
                          </span>
                        }
                      </span>
                      <span class="sk-muted sk-tr__wide" role="cell"
                        >{{ row.from }} –
                        {{
                          row.running
                            ? ('skillManagement.usage.today' | translate)
                            : row.to
                        }}
                        @if (row.running) {
                          <span class="sk-live">{{
                            'skillManagement.usage.running' | translate
                          }}</span>
                        }
                      </span>
                      <span class="sk-r sk-num sk-tr__wide" role="cell">
                        {{
                          'skillManagement.usage.months'
                            | translate: { count: row.months }
                        }}
                        @if (row.months >= 12) {
                          <span class="sk-muted sk-sub">
                            {{
                              (durationParts(row.months).months === 0
                                ? 'skillManagement.usage.durationYears'
                                : 'skillManagement.usage.durationLong'
                              ) | translate: durationParts(row.months)
                            }}
                          </span>
                        }
                      </span>
                    </div>
                  }
                }
              </div>
            }
            @if (visibleGroups.length === 0) {
              <div class="sk-empty">
                {{
                  'skillManagement.usage.emptyFiltered'
                    | translate: { months: minMonths }
                }}
              </div>
            }
          </div>
        </div>
        <p class="sk-foot-hint">
          {{ 'skillManagement.usage.footnote' | translate }}
        </p>
      }
    }
  }
</section>
